import taskManagerApi from "@/features/shared/services/taskManagerApi";
const EMPLOYEE_ROUTE = "/employee";
const EMPLOYEE_ATTACHMENT_ROUTE = "/employee_contract_attachments";
const extractErrorMessage = (error) => {
    if (error instanceof Error) {
        const serverError = error?.response?.data?.error;
        const serverMessage = error?.response?.data?.message;
        if (serverError) {
            const details = Array.isArray(serverError.details)
                ? serverError.details.join(" ")
                : serverError.details;
            return details ?? serverError.message ?? error.message;
        }
        if (serverMessage) {
            return serverMessage;
        }
        return error.message;
    }
    return "Une erreur inattendue est survenue.";
};
export const fetchEmployees = async (page = 1, filters = {}, limit = 20) => {
    try {
        const params = {
            page,
            limit,
        };
        if (filters.contract_type_code) {
            params.contract_type_code = filters.contract_type_code;
        }
        if (filters.first_name) {
            params.first_name = filters.first_name;
        }
        if (filters.last_name) {
            params.last_name = filters.last_name;
        }
        if (filters.email) {
            params.email = filters.email;
        }
        const response = await taskManagerApi.get(EMPLOYEE_ROUTE, { params });
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const fetchEmployeeById = async (id) => {
    try {
        const response = await taskManagerApi.get(`${EMPLOYEE_ROUTE}/${id}`);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const createEmployee = async (payload) => {
    try {
        const response = await taskManagerApi.post(EMPLOYEE_ROUTE, payload);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const updateEmployee = async (id, payload) => {
    try {
        await taskManagerApi.put(`${EMPLOYEE_ROUTE}/${id}`, payload);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const deleteEmployee = async (id) => {
    try {
        await taskManagerApi.delete(`${EMPLOYEE_ROUTE}/${id}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const fetchEmployeeAttachments = async (employeeId) => {
    try {
        const response = await taskManagerApi.get(`${EMPLOYEE_ATTACHMENT_ROUTE}/by-employee/${employeeId}`);
        return response.data.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const createEmployeeAttachment = async (payload) => {
    try {
        await taskManagerApi.post(EMPLOYEE_ATTACHMENT_ROUTE, payload);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
export const deleteEmployeeAttachment = async (id) => {
    try {
        await taskManagerApi.delete(`${EMPLOYEE_ATTACHMENT_ROUTE}/${id}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error));
    }
};
